module.exports = require("./sr-Cyrl-XK.d.ts");